<template>
  <!-- nudgeBottom: 1 forces the menu to reposition so the loading indicator shows/updates while the menu is already open -->
  <v-autocomplete
    v-model="modelValue"
    v-bind="$attrs"
    autocomplete="off"
    class="app-select"
    :search-input.sync="searchInput"
    :menu-props="{ nudgeBottom: 1 }"
    @change="searchInput = null"
  >
    <template v-if="$scopedSlots.item" #item="{ item, attrs, on }">
      <slot
        name="item"
        :item="item"
        :attrs="attrs"
        :on="on"
      />
    </template>
    <template v-if="$scopedSlots.selection" #selection="{ item, attrs, on }">
      <slot
        name="selection"
        :item="item"
        :attrs="attrs"
        :on="on"
      />
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import Vue from 'vue';
import { debounce } from 'lodash-es';

import { Nullable } from '@/utils/types';

export default Vue.extend({
  name: 'AppAutocomplete',

  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
  },

  data: (): { searchInput: Nullable<string> } => ({
    searchInput: null,
  }),

  computed: {
    modelValue: {
      get (): any {
        return this.value;
      },
      set (value: any): void {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    searchInput (): void {
      this.updateSearchInputDebounced(this);
    },
  },

  methods: {
    updateSearchInputDebounced: debounce(function (vm: any) {
      vm.$emit('update:search-input-debounced', vm.searchInput);
    }, 500),
  }
});
</script>
